export const getData = state => state.reportDriverSurcharges.getIn(['list', 'data'])
export const getFetching = state => state.reportDriverSurcharges.getIn(['list', 'fetching'])
export const getError = state => state.reportDriverSurcharges.getIn(['list', 'error'])

export const getDriverNote = state => state.reportDriverSurcharges.get('driver_note')
export const getModalSaving = state => state.reportDriverSurcharges.getIn(['driver_note', 'saving'])

export const getDetailsData = state => state.reportDriverSurcharges.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportDriverSurcharges.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportDriverSurcharges.getIn(['details', 'error'])
